import { atom } from 'jotai'

export const openModalState = atom(false)
